import { IParlamentarianPagedRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-paged-request';

export type ParlamentarianSearchState = {
    parameters: IParlamentarianPagedRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const ParlamentarianSearchReducer = (state: ParlamentarianSearchState, action: any): ParlamentarianSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
